import React from 'react';
import styled from '@emotion/styled';
import { colors, device } from './GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './StyledComponents';
import { SlantedPicture } from '../SlantedPicture';

const StyledHours = styled.div`
    padding: 1em 0em;
    margin: 2em 0em 4em;
    iframe {
        width: 100vw;
        height: 50vh;
        margin-bottom: 3em;
    }
    h4 {
        margin-bottom: 0.5em;
    }

    .text-container {
        margin-top: 2em;
        padding-left: 2.5em;
        position: relative;
        .symbol {
            padding-top: 2em;
            left: 0em;
            z-index: -1;
            top: -5em;
            opacity: 0.4;
            position: absolute;
        }
    }

    .contact-item {
        p {
            color: ${colors.blue};
            text-decoration: underline;
            padding-left: 1em;
            position: relative;
            top: 0.4em;
            margin-right: 2em;
        }
        margin: 0.75em 0em;
        display: flex;
        align-items: center;
    }
    .times {
        margin-top: 1em;
        .days {
            font-weight: 900;
        }
        ul {
            margin-right: 2.5em;
            list-style: none;
        }
        li {
            font-size: 18px;
            margin: 0.75em 0em;
        }

        display: flex;
    }
    .contact-container {
        display: flex;
        margin-top: 4em;
        flex-direction: column;
    }
    @media ${device.tablet} {
        li {
            text-align: left;
        }
        iframe {
            width: 100vw;
            height: 700px;
        }
        .contact-item {
            p {
                margin-right: 6.5em;
            }
        }
        .text-container {
            margin-top: -4em;
            display: flex;
            flex-direction: column;
            margin-left: 5em;
            .symbol {
                width: 100vw;
                height: 100vh;
                left: -5em;
                opacity: 0.4;
            }
        }
    }
    @media ${device.laptop} {
        margin: 4em 0em;
        iframe {
            width: 50vw;
            height: 90vh;
        }
        .contact-container {
            .contact-item {
                width: 500px;
                margin: -0.5em 0em;
            }
        }

        .text-container {
            h4 {
                margin-bottom: 0em;
            }
            .symbol {
                width: 400px;
                height: auto;
                left: -5em;
                opacity: 0.4;
            }
            margin-top: 0em;
        }
        .times {
            margin-bottom: -4em;
            .days {
                margin-right: 6.5em;
            }
        }
    }
    @media ${device.laptopL} {
        .text-container {
            .symbol {
                width: 600px;
                height: 700px;
                left: 5em;
                top: 4em;
            }
        }
    }
    @media ${device.desktop} {
        .outter-container {
            margin: 0 auto;
            display: flex;
            justify-content: center;
        }

        .text-container {
            margin-bottom: 4em;
            margin-left: 10em;
            width: 800px;
        }
    }
`;

export const Hours: React.FC = () => {
    return (
        <StyledHours>
            <div className="outter-container">
                <SlantedPicture reverse>
                    <div className="flex-container">
                        <div>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3516.7241444794618!2d-82.42688998492741!3d28.18530368259647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2ba29bb8ba8f5%3A0xa5cb651cf1a0464d!2s1942%20Highland%20Oaks%20Blvd%2C%20Lutz%2C%20FL%2033559!5e0!3m2!1sen!2sus!4v1645486713796!5m2!1sen!2sus"
                                width="100%"
                                loading="lazy"
                                title="Animal Country"
                                height="100%"
                                frameBorder="0"
                                style={{ border: 0 }}
                                aria-hidden="false"
                            />
                        </div>

                        <div className="text-container">
                            <StaticImage
                                className="symbol"
                                quality={100}
                                src="../../images/svgs/brand-symbol.svg"
                                alt="craft smiles graphic logo"
                                placeholder="none"
                            />
                            <h4>Hours</h4>
                            <div className="times">
                                <ul className="days">
                                    <li>Monday</li>
                                    <li>Tuesday</li>
                                    <li>Wednesday</li>
                                    <li>Thursday</li>
                                    <li>Friday</li>
                                    <li>Saturday</li>
                                    <li>Sunday</li>
                                </ul>
                                <ul>
                                    <li>7am - 6pm</li>
                                    <li>7am - 6pm</li>
                                    <li>9am - 6pm</li>
                                    <li>7am-6pm</li>
                                    <li>Appointment Only</li>
                                    <li>Closed</li>
                                    <li>Closed</li>
                                </ul>
                            </div>

                            <div className="contact-container">
                                <h4>Contact Us</h4>
                                <a rel="noopener noreferrer" href="tel:8132354143">
                                    <div className="contact-item">
                                        <StaticImage
                                            src="../../images/svgs/mobile-blue.svg"
                                            placeholder="none"
                                            alt="mobile icon"
                                        />
                                        <p style={{ position: 'relative', right: '.45em' }}>
                                            (813) 235-4143
                                        </p>
                                    </div>
                                </a>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="mailto:info@craftyoursmile.com"
                                >
                                    <div className="contact-item">
                                        <StaticImage
                                            src="../../images/svgs/mail-blue.svg"
                                            placeholder="none"
                                            alt="mail icon"
                                        />
                                        <p>info@craftyoursmile.com</p>
                                    </div>
                                </a>
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://www.google.com/maps/place/1942+Highland+Oaks+Blvd,+Lutz,+FL+33559/data=!4m2!3m1!1s0x88c2ba29bb8ba8f5:0xa5cb651cf1a0464d?sa=X&ved=2ahUKEwiIkOORj5H2AhUVlYkEHahrCugQ8gF6BAgSEAE"
                                >
                                    <div className="contact-item">
                                        <StaticImage
                                            src="../../images/svgs/map-blue.svg"
                                            placeholder="none"
                                            alt="map icon"
                                        />
                                        <p>1942 Highland Oaks Blvd Suite B, Lutz, FL 33559</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </SlantedPicture>
            </div>
        </StyledHours>
    );
};
